export const cilAccountLogout = ["24 24","<path d='M3.617 12.752l12.872-0v-1.5h-12.872l3.518-3.518-1.061-1.061-5.329 5.329 5.329 5.329 1.061-1.061-3.518-3.518z'></path><path d='M7.5 0.75v1.5h14.25v19.5h-14.25v1.5h15.75v-22.5h-15.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-account-logout.js
// module id = null
// module chunks = 